// extracted by mini-css-extract-plugin
export default {"label":"_hWq6DK_GK686Ykrjr1c3"};